
export function reload() {
  window.location.reload();
}
